export const getAdministeredDose = (
  values: (number | null)[],
  medications: string
) => {
  const validValues = values.filter(Boolean) as number[];

  if (!validValues.length) {
    return "Administered dose: -";
  }

  const sum = validValues.reduce((acc, dose) => acc + +dose, 0);
  return `Administered dose: ${sum} mLs ${medications}`;
};
